import { render } from "./InventarioUbicacionPage.vue?vue&type=template&id=9f459d24&scoped=true"
import script from "./InventarioUbicacionPage.vue?vue&type=script&lang=js"
export * from "./InventarioUbicacionPage.vue?vue&type=script&lang=js"

import "./InventarioUbicacionPage.vue?vue&type=style&index=0&id=9f459d24&scoped=true&lang=css"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f459d24"]])

export default __exports__